import React, { useState } from 'react';
import { Card, CardHeader, CardContent, ToggleButtonGroup, ToggleButton, Box } from '@mui/material';
import { Devices } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import ReadTimeChart from '../charts/ReadTimeChart';
import ReadTimeInfo from './ReadTimeInfo';
import RichTooltip from '../../RichTooltip';

const ReadTimeByDeviceCard = ({ a, b, aColour, bColour }) => {
    const [device, setDevice] = useState('desktop');

    return (
        <Card sx={{ height: '100%', m: 0, p: 0 }}>
            <CardHeader
                sx={{
                    m: 0,
                    py: 1
                }}
                title="Read Time by Device"
                slotProps={{
                    title: {
                        variant: 'h6',
                        fontWeight: 'normal'
                    }
                }}
                avatar={<Devices />}
                action={(
                    <RichTooltip>
                        <ReadTimeInfo />
                    </RichTooltip>
                )}
            />
            <CardContent
                sx={{
                    m: 0,
                    px: 2,
                    py: 0,
                    '&:last-child': {
                        paddingBottom: 2
                    }
                }}
            >
                {b ? (
                    <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <ReadTimeChart
                                data={a.readTimesByDevice ? a.readTimesByDevice[device] : null}
                                colour={aColour}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <ReadTimeChart
                                data={b.readTimesByDevice ? b.readTimesByDevice[device] : null}
                                colour={bColour}
                            />
                        </Grid>
                    </Grid>
                ) : (
                    <ReadTimeChart
                        data={a.readTimesByDevice ? a.readTimesByDevice[device] : null}
                        colour={aColour}
                    />
                )}
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <ToggleButtonGroup
                        value={device}
                        exclusive
                        onChange={(e, device) => device && setDevice(device)}
                        aria-label="Device"
                        color="primary"
                    >
                        <ToggleButton value="desktop">
                            Desktop
                        </ToggleButton>
                        <ToggleButton value="mobile">
                            Mobile
                        </ToggleButton>
                        <ToggleButton value="tablet">
                            Tablet
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ReadTimeByDeviceCard;